import React, {useEffect, useContext, useState} from 'react';
import {BroadcastChannel} from 'broadcast-channel';
import axios from 'axios';

import Conf from 'utils/Conf';
import Context from 'utils/Context';
import Utils from 'utils/Utils';
import SeanceLogin from 'components/Auth/SeanceLogin';
import SuspenseSpinner from 'components/SuspenseSpinner';
import OldSeance from 'components/Seance';

import Ticketing from './Ticketing';
import VirtualRoomContainer from './VirtualRoom.container';
import NoAccessError from './NoAccessError';

const channel = new BroadcastChannel('foobar');

const Seance = ({params}) => {
  const {appState, modele, geoloc, country} = useContext(Context);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seanceIndex, setSeanceIndex] = useState(null);
  const [loggedIn, setLoggedIn] = useState(!!appState.user.email);
  const [hasTicket, setHasTicket] = useState(false);

  // const handleFullScreeenChange = () => {
  //   if (document.fullscreenElement) {
  //     // this.setState({full: true});
  //     // TODO: set state ?
  //     document.body.classList.add('fullscreen');
  //   } else {
  //     // this.setState({full: false});
  //     document.body.classList.remove('fullscreen');
  //   }
  // };

  useEffect(() => {
    channel.postMessage(`/request/seance/${params.id}`);
    channel.addEventListener('message', msg => {
      const seanceId = msg.replace('/request/seance/', '');
      if (seanceId === params.id) {
        channel.postMessage('denied');
      }
      if (msg === 'denied') {
        setError('otherTab');
      }
    });

    // Fetch seanceIndex
    axios
      .get(`${Conf.apiBaseUriLegacy}/seance/${params.id}/index`, {withCredentials: true})
      .then(res => {
        if (!res.data.seance || res.data.seance.length === 0) {
          throw new Error();
        }
        setSeanceIndex(res.data.seance);
        setLoading(false);
      })
      .catch(() => {
        setError('noSeance');
        setLoading(false);
      });
  }, [params.id, appState.uuid, params.hash]);

  useEffect(() => {
    // Fetch seance access
    axios
      .get(`${Conf.apiBaseUriLegacy}/access/seance/${params.id}`, {
        params: {
          hash: params.hash,
          uuid: appState.uuid,
        },
        withCredentials: true,
      })
      .then(res => {
        if (res.data.authorized) {
          setHasTicket(true);
        } else if (res.data.msg === 'Utilisateur non connecté') {
          return;
        } else if (res.data.msg === 'ticket non valide') {
          setHasTicket(false);
        } else {
          setError(res.data.msg);
        }
        return;
      });
  }, [params.id, loggedIn, params.hash, appState.uuid]);

  // DEBUT DU RENDER

  if (loading) {
    return <SuspenseSpinner />;
  }

  if (error) {
    return <NoAccessError errorCode={error} />;
  }

  if (!appState.user.email && !params.hash) {
    return (
      <SeanceLogin
        seance={seanceIndex}
        appState={appState}
        modele={modele}
        open={!loggedIn}
        onLogin={() => setLoggedIn(true)}
        onClose={() => setLoggedIn(false)}
      />
    );
  }

  const isLocal = Utils.isSeanceLocal(seanceIndex, geoloc, country);

  if (!hasTicket && !isLocal) {
    return <NoAccessError errorCode="notLocal" />;
  }

  if (!hasTicket) {
    return <Ticketing seance={{...seanceIndex, local: isLocal}} onSuccess={() => setHasTicket(true)} />;
  }

  if (!seanceIndex.is_aws_video) {
    return <OldSeance params={params} appState={appState} />;
  }
  return <VirtualRoomContainer params={params} />;
};

export default Seance;
